// AiLys partner portal /login page.
//
// Renders a single CTA button that posts the user to /api/auth/start
// which redirects to WorkOS Hosted UI for credential entry + 2FA.
// Phase 6.1 Chunk d.

import { useEffect } from 'react';
import { useLang } from '../i18n';
import { colors, mutedStyle } from '../components/ui';

export default function Login({ next }: { next?: string }) {
  const { t } = useLang();

  useEffect(() => {
    document.title = t.login.pageTitle;
  }, [t]);

  const startUrl = next ? `/api/auth/start?next=${encodeURIComponent(next)}` : '/api/auth/start';

  return (
    <main
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        background: colors.bg,
        color: colors.text,
      }}
    >
      <div style={{ maxWidth: '420px', width: '100%' }}>
        <div
          style={{
            fontFamily: 'monospace',
            fontSize: '10px',
            letterSpacing: '0.22em',
            textTransform: 'uppercase',
            color: colors.cyan,
            marginBottom: '12px',
          }}
        >
          {t.login.brand}
        </div>
        <h1
          style={{
            fontSize: '2rem',
            fontWeight: 600,
            margin: '0 0 24px',
          }}
        >
          {t.login.heading}
        </h1>
        <p
          style={{
            ...mutedStyle,
            fontSize: '0.9rem',
            margin: '0 0 32px',
          }}
        >
          {t.login.subtitle}
        </p>
        <a
          href={startUrl}
          style={{
            display: 'block',
            textAlign: 'center',
            padding: '12px 24px',
            borderRadius: '12px',
            background: `linear-gradient(135deg, ${colors.cyanDark} 0%, ${colors.cyanMid} 100%)`,
            color: colors.bg,
            fontWeight: 600,
            textDecoration: 'none',
            fontSize: '0.95rem',
          }}
        >
          {t.login.ssoButton}
        </a>
        <p
          style={{
            fontSize: '0.8rem',
            lineHeight: 1.5,
            color: colors.mutedLight,
            marginTop: '32px',
            textAlign: 'center',
          }}
        >
          {t.login.newPartner}{' '}
          <a
            href="https://www.ailysagency.ca/agencies/partner-program"
            style={{ color: colors.cyan }}
          >
            {t.login.applyLink}
          </a>
          .
        </p>
        <p
          style={{
            fontSize: '0.75rem',
            color: colors.mutedLighter,
            marginTop: '16px',
            textAlign: 'center',
          }}
        >
          {t.login.lostAccess}{' '}
          <a
            href="mailto:partners@ailysagency.ca"
            style={{ color: colors.muted }}
          >
            {t.login.lostAccessEmail}
          </a>
        </p>
      </div>
    </main>
  );
}
